import { memo, useEffect, useRef } from 'react';

function PageCanvasBase({ doc, originalIndex, rotation, scale, onSize }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    let alive = true;
    let renderTask;

    (async () => {
      if (!doc) return;
      const page = await doc.getPage(originalIndex + 1);
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const viewport = page.getViewport({ scale: scale * dpr, rotation });
      const cssViewport = page.getViewport({ scale, rotation });
      const canvas = canvasRef.current;
      if (!canvas || !alive) return;
      canvas.width = Math.ceil(viewport.width);
      canvas.height = Math.ceil(viewport.height);
      canvas.style.width = `${Math.ceil(cssViewport.width)}px`;
      canvas.style.height = `${Math.ceil(cssViewport.height)}px`;
      const ctx = canvas.getContext('2d', { alpha: false });
      renderTask = page.render({ canvasContext: ctx, viewport });
      try {
        await renderTask.promise;
        if (alive) onSize?.({ width: cssViewport.width, height: cssViewport.height });
      } catch {}
    })();

    return () => {
      alive = false;
      renderTask?.cancel?.();
    };
  }, [doc, originalIndex, rotation, scale, onSize]);

  return <canvas ref={canvasRef} className="page-canvas" />;
}

export const PageCanvas = memo(PageCanvasBase);
